import type { SiteCreatePayload } from "@/customTypings/site/Site";
import type { SiteDeletedRestoreAvailableConflict } from "@/utils/site/siteCreateConflict";
import {
    SITE_CREATE_CONFLICT,
    SiteCreateConflictError,
    isSiteDeletedRestoreAvailableConflict,
} from "@/utils/site/siteCreateConflict";
import { createPayloadSpreadRestoreConfig } from "./createPayloadSpreadRestoreConfig";

export function createSiteRestoreConfig<TDetail extends { id: string }>(options: {
    restoreDeletedWithCreateValues: (payload: SiteCreatePayload & { id: string }) => Promise<TDetail>;
    onRestored: (detail: TDetail, siteName: string) => void;
}) {
    return createPayloadSpreadRestoreConfig<
        SiteDeletedRestoreAvailableConflict,
        SiteCreatePayload,
        SiteCreatePayload & { id: string },
        TDetail,
        SiteCreateConflictError
    >({
        ConflictErrorClass: SiteCreateConflictError,
        isRestoreAvailable: isSiteDeletedRestoreAvailableConflict,
        deletedRestoreAvailableCode: SITE_CREATE_CONFLICT.deletedRestoreAvailable,
        modalTitle: "Restore deleted site?",
        modalBody: () =>
            "A deleted Site matching these details already exists. Do you want to restore it using the details you entered?",
        successLabel: (conflict) => conflict.existingSiteName,
        restoreDeletedWithCreateValues: options.restoreDeletedWithCreateValues,
        onRestored: (detail, conflict) => options.onRestored(detail, conflict.existingSiteName),
    });
}
